import React, { useMemo } from 'react';

import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

import { useCampaignLeaderboardInfiniteQuery, useSelfCampaignLeaderboardMe } from '@query';

import { CampaignLeaderboardItem, SelfCampaignLeaderboardMe } from '@api';

import { useAuth } from '@shared/common/providers/AuthProvider';

import CampaignLeaderboardTable from './CampaignLeaderboardTable';

export interface CampaignLeaderboardViewProps {
  id?: string;
  className?: string;
  items: CampaignLeaderboardItem[];
  me?: SelfCampaignLeaderboardMe;
  query: UseInfiniteQueryResult<InfiniteData<any, unknown>, unknown>;
}

interface CampaignLeaderboardProps {
  campaignSlug: string;
  className?: string;
  id?: string;
}

const CampaignLeaderboard = ({
  id: elementId,
  campaignSlug,
  className,
}: CampaignLeaderboardProps) => {
  const { isAuth } = useAuth();
  const { data: campaignLeaderboardMe } = useSelfCampaignLeaderboardMe(campaignSlug, {
    enabled: isAuth,
  });
  const campaignLeaderboardInfiniteQuery = useCampaignLeaderboardInfiniteQuery(campaignSlug);

  const { data } = campaignLeaderboardInfiniteQuery;

  const leaderboard = useMemo(() => {
    const participants = data?.pages.flatMap((page) => page) || [];

    if (!isAuth || !campaignLeaderboardMe?.id) {
      return participants;
    }

    const hasSelfParticipant = !!participants.find(({ id }) => id === campaignLeaderboardMe.id);

    if (!hasSelfParticipant) {
      participants.push(campaignLeaderboardMe);
    }

    return participants;
  }, [data, campaignLeaderboardMe, isAuth]);

  return (
    <CampaignLeaderboardTable
      me={campaignLeaderboardMe}
      items={leaderboard}
      query={campaignLeaderboardInfiniteQuery}
      className={className}
      id={elementId}
    />
  );
};

export default CampaignLeaderboard;
